// extracted by mini-css-extract-plugin
export default {"socialsHolder":"Socials_socialsHolder__DnnJj"};